import { useEffect } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { useAuthStore } from "../Zustand/auth.store";
import { ACCESS_TOKEN_KEY } from "../hooks/useAccessToken";

export default function AuthBridge() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const setFromEntraId = useAuthStore((s) => s.setFromEntraId);
  const clear = useAuthStore((s) => s.clear);

  useEffect(() => {
    if (!account) {
      sessionStorage.removeItem(ACCESS_TOKEN_KEY);
      clear();
      return;
    }

    const idToken = account.idToken;
    const rawClaims = account.idTokenClaims || {};

    const mappedClaims = {
      firstName: rawClaims.given_name || "",
      lastName: rawClaims.family_name || "",
      workdayUsername:
        rawClaims.preferred_username || (rawClaims.email as string) || "",
      groups: (rawClaims.groups as string[]) || [],
      email: (rawClaims.email as string) || "",
      name: rawClaims.name || "",
    };

    const acquireAndStoreAccessToken = async () => {
      const tokenRequest = {
        scopes: ["User.Read", "openid", "profile", "email"],
        account: account,
      };

      try {
        const response = await instance.acquireTokenSilent(tokenRequest);

        if (response?.accessToken) {
          sessionStorage.setItem(ACCESS_TOKEN_KEY, response.accessToken);
          setFromEntraId({
            token: idToken,
            accessToken: response.accessToken,
            claims: mappedClaims,
          });
        }
      } catch (silentError) {
        console.error(
          "MSAL: acquireTokenSilent failed, triggering interactive re-auth",
          silentError
        );
        setFromEntraId({ token: idToken, claims: mappedClaims });
        try {
          await instance.acquireTokenRedirect(tokenRequest);
        } catch (redirectError) {
          console.error("MSAL: acquireTokenRedirect failed", redirectError);
        }
      }
    };

    acquireAndStoreAccessToken();
  }, [account, instance, setFromEntraId, clear]);

  return null;
}
